import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { AdminModal } from "@/components/pageSettings/AdminModal";

const BTN = "border-2 border-black px-3 py-1.5 text-[10px] font-bold uppercase tracking-widest transition-colors duration-100 disabled:opacity-40";

// One click: give every buyer still on the site default its own ready-made thank-you layout.
export function SpreadLayoutsDialog({ onClose, onDone }) {
  const [plan, setPlan] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    api.get("/admin/thank-you-layouts/spread").then((r) => setPlan(r.data.plan)).catch(() => setPlan(false));
  }, []);
  const apply = () => {
    setBusy(true);
    api.post("/admin/thank-you-layouts/spread")
      .then((r) => { toast.success(`${r.data.updated} buyer${r.data.updated === 1 ? "" : "s"} now have their own layout`); onDone?.(); onClose(); })
      .catch((e) => toast.error(e.response?.data?.detail || "Couldn't change the layouts"))
      .finally(() => setBusy(false));
  };
  const footer = (
    <div className="flex justify-end gap-2">
      <button type="button" onClick={onClose} className={`${BTN} bg-white hover:bg-zinc-100`} data-testid="spread-layouts-cancel">Cancel</button>
      <button type="button" onClick={apply} disabled={busy || !plan?.length} data-testid="spread-layouts-apply"
              className={`${BTN} bg-black text-white hover:bg-emerald-700`}>{busy ? "Saving…" : "Apply to these buyers"}</button>
    </div>
  );
  return (
    <AdminModal eyebrow="Thank-you layouts" title="Mix up layouts for current buyers" onClose={onClose} footer={footer} testId="spread-layouts">
      <p className="mb-3 text-[11px] text-zinc-600">
        Buyers still on the site default each get one of the ready-made layouts, spread evenly. Buyers who already have a layout keep it.
        You can change any buyer later from &ldquo;Preview thank-you page&rdquo;.
      </p>
      {plan === null && <div className="label-mono">Loading…</div>}
      {plan === false && <div className="text-sm text-red-700">Couldn&apos;t load. Try again.</div>}
      {plan?.length === 0 && <div className="text-sm" data-testid="spread-layouts-none">Every real buyer already has its own layout. Test buyers are left out.</div>}
      {plan?.length > 0 && (
        <table className="w-full text-xs" data-testid="spread-layouts-plan">
          <thead><tr className="border-b-2 border-black text-left"><th className="py-1 label-mono">Buyer</th><th className="py-1 label-mono">New layout</th></tr></thead>
          <tbody>
            {plan.map((r) => (
              <tr key={r.id} className="border-b border-zinc-200" data-testid={`spread-layouts-row-${r.id}`}>
                <td className="py-1.5 font-bold">{r.firm_name}</td><td className="py-1.5">{r.design_name}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </AdminModal>
  );
}
